import { useCallback, useMemo } from 'react';
import useEventAttendees from 'src/hooks/events/useEventAttendees';

const useAttendance = () => {
  const { attendees } = useEventAttendees({});
  const attendingCharacterIds = useMemo(
    () =>
      attendees
        .map(atd => atd.attendeeCharacters.map(atc => atc.character.id))
        .flat(),
    [attendees],
  );
  const isAttending = useCallback(
    ({ characterId }: { characterId?: number }) =>
      characterId && attendingCharacterIds.includes(characterId),
    [attendingCharacterIds],
  );

  return { isAttending };
};

export default useAttendance;
